import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Utils from './Utils';
import Grid from '@material-ui/core/Grid';

export default class DialogLogin extends Component {

  constructor(props){
    super(props);
    
  this.state={
    myId: 0, //ID
    myTime: '', //Čas rezervace
    myPerson: '', //Jméno přihlášeného
    myDialogOpen: false,
    myDialogAnswerOpen: false,
    myDialogNameOpen: false, 
    mySucces: false
    }
  
  // Tenhle binding je nezbytný protože JS má problém s this v callbacku    
  this.handleChangeName = this.handleChangeName.bind(this);
  this.handleSubmit = this.handleSubmit.bind(this);
  }

 
  handleDialogAnswerClose = () => {
    this.setState({myDialogAnswerOpen: false}); // zavře dialog Answer
    this.props.onClickClose(); // Zavře původní dialog
  };

  handleDialogClose = () => {
    this.setState({myDialogOpen: false}); // zavře dialog 
    this.props.onClickClose(); // Zavře původní dialog
  };
  
handleChangeName(event) {
    this.setState({myPerson: event.target.value });   
}

handleDialogNameClose = () => {
  this.setState({myDialogNameOpen: false}); // zavře dialog Name 
};

handleSubmit() {
 
// Ověření zadání jména
if ( this.state.myPerson.trim().length === 0 ){
  this.setState({myDialogNameOpen: true }); 
  return;
}


  var formData = new FormData();
        formData.append('updateEvent', true); // Metoda getReservations
        formData.append('EventId', this.props.myId);
        formData.append('EventName', this.state.myPerson);
        
        let fetchData = { 
          method: 'POST', body: formData,      
          headers: {
             headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          },  
        }
  
      // A posílám
      fetch(Utils.getURL(), fetchData)   
      .then(response => response.json())
      .then(data => {          
          if ( data["success"]) {
            console.log('Jméno:',  data["ad_person"]);
            this.setState({mySucces: true }); // Po přihlášení na hlavní stránku              
            }
          else{
            console.log('Neúspěch:', data["message"]);
            this.setState({mySucces : false })                              
            }
        this.setState({myDialogAnswerOpen: true }); 
      })
      .catch((error) => {
        console.error('Chyba:', error);
      });    
}

/**
 * dá formátovanou odpověď po přihlášení
 */
getAnswer(){
  
  if ( this.state.mySucces ){
    return <p><h3> Jste přihlášeni.</h3></p>
  } 
  else {
    return <p><h3>Pozor, nepodařilo se přihlásit!</h3>
    Prosím zkuste to znovu.</p>
  }
}

render() {
  return(
  <div>
    {/* Odpověď */}
      <Dialog disableBackdropClick
          open={this.state.myDialogAnswerOpen}  
          onClose={this.handleDialogAnswerClose}
        >
        <DialogTitle  id="answer-dialog-title">{this.props.myName}</DialogTitle>
        <DialogContent>
        <DialogContentText id="answer-dialog-description">
          {this.getAnswer()}
          
            </DialogContentText>
            </DialogContent>
        <DialogActions>
        <p className="center">
          <Button color="primary" variant="contained" 
              onClick={this.handleDialogAnswerClose} >
            OK
          </Button>          
        </p>
          </DialogActions>         
      </Dialog>
        
    {/* Nezadané jméno */}
      <Dialog disableBackdropClick
          open={this.state.myDialogNameOpen}  
          onClose={this.handleDialogNameClose}
        >
        <DialogContent>
        <DialogContentText id="name-dialog-description">          
          Prosím zadejte jméno.
            </DialogContentText>
            </DialogContent>
        <DialogActions>
        <p className="center">
          <Button color="primary" variant="contained" 
              onClick={this.handleDialogNameClose} >
            OK
          </Button></p>
          </DialogActions>         
      </Dialog>


    {/* Zadávací dialog */}

      <Dialog disableBackdropClick
        open={this.props.myopen} aria-labelledby="alert-dialog-title"  aria-describedby="alert-dialog-description"
        onClose={this.props.onClickClose}
        >

        <DialogTitle  id="form-dialog-title">{this.props.myName}</DialogTitle>
        <DialogContent>
        <DialogContentText id="alert-dialog-description">
        {<b>Adorace {this.props.myTime}</b>}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            Zadejte jméno 
          </DialogContentText>
          <Grid container spacing={1}>
          <Grid item >
          <FormControl variant="outlined" >
             <TextField  variant="outlined" type="string" id="name" label="Jméno"
              name="name"   
              onChange = {this.handleChangeName}
              />

          </FormControl>
          
          </Grid>
          
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button color="primary" 
            onClick={this.props.onClickClose}
            >
            Zrušit
          </Button>
          <p className="space5"></p>
          
          <Button  color="primary" variant="contained" autoFocus
            onClick={this.handleSubmit}
            >
            Přihlásit
          </Button>
          <p className="space8"></p>
          </DialogActions>
        
      </Dialog>
      </div>
    );
}
}